import z from 'zod';

export const systemStatusSchema = z
	.object({
		version: z.string(),
		date: z.coerce.date(),
	})
	.describe('SystemStatus');
